import axios from 'axios';

const client = axios.create({
    baseURL: '/',
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

client.interceptors.request.use((config) => {
    const token = document.head.querySelector('meta[name="csrf-token"]');
    if (token) config.headers['X-CSRF-TOKEN'] = token.content;
    return config;
});

client.interceptors.response.use(
    (response) => {
        if (response.data && typeof response.data.success === 'boolean') {
            response.data = response.data.data;
        }
        return response;
    },
    (error) => Promise.reject(error),
);

export const authService = {
    login(identifier, password) {
        return client.post('/auth/login', { identifier: identifier.trim(), password });
    },

    setPassword(password, passwordConfirmation) {
        return client.post('/auth/password/set', { password, password_confirmation: passwordConfirmation });
    },

    me() {
        return client.get('/auth/me');
    },

    logout() {
        return client.post('/auth/logout');
    },
};
